import { render } from "./TaskBlock.vue?vue&type=template&id=13d89a32&scoped=true&ts=true"
import script from "./TaskBlock.vue?vue&type=script&lang=ts"
export * from "./TaskBlock.vue?vue&type=script&lang=ts"

import "./TaskBlock.vue?vue&type=style&index=0&id=13d89a32&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13d89a32"]])

export default __exports__